fx.ns("shared.stage", class ToolBarButton extends shared.stage.ToolBarAction{
    
    constructor(command, component, container)
    {
        super(command, component, container);
    }

    onReady(){
        super.onReady();

        if (!this.label)
            this.addClass("nolabel");

        if (this.command.class)
            this.addClass(this.command.class);

        this.on("click", this.click);
    }

    show()
    {
        super.show();

        this.css("display", "inline-block");

        this.selectionChanged();
    }

    hide()
    {
        super.hide();
        this.css("display", "none");
    }
   
    selectionChanged()
    {
        if (this.command.enabledField)
            this.command.disabled = !this.component[ this.command.enabledField ];
        
        if (this.command.disabled)
            this.disable();
        else
            this.enable();
    }

    click()
    {
        if (this.enabled)
            this.action();
    }

    render()
    {
        return this.icon.render() + (this.label ? '<div class="label">' + this.label + '</div>' : '');
    }
});